/* eslint jsx-a11y/href-no-hash: "off" */
import React from 'react'
import {connect} from 'react-redux'
import {modelsFromObject} from '../../helpers/models-from-object.js'
import {getPagesFromArray} from '../../helpers/get-pages-from-array.js'
import SubmissionListViewPaginationGroup from './SubmissionListViewPaginationGroup'
import uniqBy from 'lodash/uniqBy'
import SubmissionMenuOption from './SubmissionMenuOption'

class SubmissionListViewMenu extends React.Component {


  handleClick(model) {
    //This is passed down and back up through MockActionLink
    this.props.arenaMenuSnapshot.submit(model);
  }

  handleHover(model) {
    //This is passed down and back up through MockActionLink
    this.props.arenaMenuSnapshot.setActive(model);
  }

  //NOTE: These arrow handlers have a lot of duplicate code from `render`, but at the moment, it's simple to leave it like this
  //Find the PREVIOUS page
  handleUpArrowClick(e) {
    e.preventDefault();

    //Get the array of options
    const optionKeyArray = Object.keys(this.props.arenaMenuSnapshot.optionsData);

    //Determine which page the current selected option is on.
    const pageMapArray = getPagesFromArray(optionKeyArray, 4);

    //Identify the selected option and page
    const selectedOptionIndex = this.props.arenaMenuSnapshot.currentlySelectedOptionData.viewBag.index;
    const selectedOptionPage = pageMapArray[selectedOptionIndex] - 1; //Take out the paging starting at 1...

    //Get a list of options that exist on our desired page index.
    let nextPage = [];
    pageMapArray.forEach((optionPage, index) => {
      if (optionPage === selectedOptionPage) {
        nextPage.push(index)
      }
    });

    //If we populated anything in nextPage, use the first one. (first option of the 'next' page)
    if (nextPage.length) {
      const nextOptionKey = optionKeyArray[ nextPage[0] ];
      const nextOptionModel = this.props.arenaMenuSnapshot.optionsData[nextOptionKey]

      //Finally, set this next one to active
      this.props.arenaMenuSnapshot.setActive(nextOptionModel)
    }
  }

  //Fine the "first" option on the NEXT page down.
  handleDownArrowClick(e) {
    e.preventDefault();

    //Get the array of options
    const optionKeyArray = Object.keys(this.props.arenaMenuSnapshot.optionsData);

    //Determine which page the current selected option is on.
    const pageMapArray = getPagesFromArray(optionKeyArray, 4);

    //Identify the selected option and page
    const selectedOptionIndex = this.props.arenaMenuSnapshot.currentlySelectedOptionData.viewBag.index;
    const selectedOptionPage = pageMapArray[selectedOptionIndex] + 1; //Take out the paging starting at 1...

    //If we populated anything in nextPage, use the first one. (first option of the 'next' page)
    let nextPage = [];
    pageMapArray.forEach((optionPage, index) => {
      if (optionPage === selectedOptionPage) {
        nextPage.push(index)
      }
    });


    if (nextPage.length) {
      const nextOptionKey = optionKeyArray[ nextPage[0] ];
      const nextOptionModel = this.props.arenaMenuSnapshot.optionsData[nextOptionKey]

      //Finally, set this next one to active
      this.props.arenaMenuSnapshot.setActive(nextOptionModel)
    }
  }


  getPaginationPages(selectedIndex, array) {
    return array.map((option,i) => {
      return i === selectedIndex;
    }); //[true, false, false, ...etc]
  }


  getPaginationDisplayValue(pageCountArray) {

    if ( //Sometimes don't show this column at all.
      this.props.isTouchMode || //we are in touch mode
      pageCountArray.length === 1 //only 1 page
    ) {
      return "none"
    }

    return "flex"
  }

  render() {

    const containerStyle = {
      //Allow scrolling on touchMode only, not desktop
      overflow: this.props.isTouchMode ? "scroll" : "hidden",
      WebkitOverflowScrolling: "touch"
    };

    const listContainerStyle = { //This one is offset up or down based on the selected index

      display: "flex", //contains pagination column and content column

      // transition: `top 0.3s`
    };






    const optionKeyArray = Object.keys(this.props.arenaMenuSnapshot.optionsData).filter(key => {
      //Do not include BACK
      return key !== "listview-back"
    });

    //Determine which page the selected option is on.
    const pageMapArray = getPagesFromArray(optionKeyArray, 4);

    //Lodash uniqBy figures out how many pages are in the pageMapArray
    //(by eliminating duplicates)
    const pageCountArray = uniqBy(pageMapArray);

    //Identify the selected option and page
    const selectedOptionIndex = this.props.arenaMenuSnapshot.currentlySelectedOptionData.viewBag.index;
    const selectedOptionPage = pageMapArray[selectedOptionIndex] - 1; //Take out the paging starting at 1...

    const paginationColumnStyle = {
      width: "2em",
      height: "12em", //same as containerStyle
      //Do not show this on touchMode
      display: this.getPaginationDisplayValue(pageCountArray),
      flexDirection: "column",
      justifyContent: "space-between"
    };


    const contentColumnStyle = {
      position: "relative",
      transform: `translateY(calc(${-selectedOptionPage} * 12em)`,
      transition: 'transform 0.3s',
      flex: "1"
    };

    const columnItemsContainerStyle = {
      height: "12em" //TODO: this should be the exact height of the viewable area of items (Should touch the bottom of the screen)
    };



    /* Pagination stuff */
    const arrowAnchorStyle = {
      paddingTop: "0.5em",
      paddingBottom: "0.5em"
    };
    const arrowStyle = {
      display: "block",
      width: "1em",
      margin: "0 auto"
    };

    const topArrowAnchorStyle = {
      ...arrowAnchorStyle,
      opacity: selectedOptionPage === 0 ? 0 : 1 //Hide this "up" arrow if first page is active

    };
    const bottomArrowAnchorStyle = {
      ...arrowAnchorStyle,
      opacity: pageCountArray.length-1 === selectedOptionPage ? 0 : 1 //Hide this "down" arrow if last page is active
    };

    const arenaMenuSnapshot = this.props.arenaMenuSnapshot;
    return (
      <div style={containerStyle}>
        <div style={listContainerStyle}>

          <div style={contentColumnStyle}>
            <div style={columnItemsContainerStyle}>
              {
                modelsFromObject(arenaMenuSnapshot.optionsData).filter(option => {
                  //Do not include the BACK option
                  return option.id !== "listview-back"
                }).map((option, i) => {
                  return (
                    <SubmissionMenuOption
                      key={i}
                      model={option}
                      handleClick={this.handleClick.bind(this)}
                      handleHover={this.handleHover.bind(this)}
                      vW={this.props.vW}
                      isTouchMode={this.props.isTouchMode}
                    />
                  )
                })
              }
            </div>
          </div>

          <div style={paginationColumnStyle}>
            <a href="#" style={topArrowAnchorStyle} onClick={this.handleUpArrowClick.bind(this)}>
              <img style={arrowStyle} src="/images/misc/up-arrow.svg" alt="Prev Page" />
            </a>
            <SubmissionListViewPaginationGroup pages={this.getPaginationPages(selectedOptionPage, pageCountArray)} />
            <a href="#" style={bottomArrowAnchorStyle} onClick={this.handleDownArrowClick.bind(this)}>
              <img style={arrowStyle} src="/images/misc/down-arrow.svg" alt="Next Page" />
            </a>
          </div>

        </div>
      </div>
    );
  }
}
export default connect((state, props) => {
  return {
    isTouchMode: state.global.isTouchMode,

    arenaMenuSnapshot: state.battle.arenaMenuSnapshot,
    vW: state.global.vW
  }
})(SubmissionListViewMenu)




// WEBPACK FOOTER //
// ./src/battle/ArenaView/SubmissionListViewMenu.js